import PropTypes from 'prop-types';
import classNames from 'classnames';
import GoogleMapsLoader from 'google-maps';
import React from 'react';
import ReactDOM from 'react-dom';

const EMPTY_SHIPPING_ADDRESS = {
  name: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipCode: ''
};

GoogleMapsLoader.KEY = 'AIzaSyDAxMYdpNMx0ZjlJrFGwmQkQnYVq2rBRLc';
GoogleMapsLoader.LIBRARIES = ['places'];

class AddressField extends React.Component {
  render() {
    const {
      value,
      onChange,
      label,
      autoComplete,
      isBig,
      disabled
    } = this.props;

    return (
      <div
        className={classNames('form-group', {
        'col-6': !isBig,
        'col-12': isBig
      })}>
        <label>{label}</label>
        <input
          type="text"
          className="form-control"
          name="form-control"
          autoComplete={autoComplete}
          onChange={onChange}
          value={value}
          disabled={disabled}
          ref={'input'}/>
      </div>
    )
  }
}

class AddressFields extends React.Component {
  componentDidMount() {
    this.loadGoogleAutocomplete();
  }

  updateAddress = (updated_object) => {
    this.props.updateAddress(updated_object);
  }

  loadGoogleAutocomplete = () => {
    GoogleMapsLoader.load((google) => {
      const autocomplete = new google
        .maps
        .places
        .Autocomplete(ReactDOM.findDOMNode(this.refs.address1.refs.input), {
          componentRestrictions: {
            country: ['us']
          },
          types: ['address']
        });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        const {address_components} = place;

        const googleTypeToValue = {};

        address_components.forEach((component) => {
          const type = component.types[0];
          googleTypeToValue[type] = component;
        });

        const {street_number, route, locality, administrative_area_level_1, postal_code} = googleTypeToValue;

        const getNameFromComponent = (component, {use_short_name} = {}) => {
          if (!component) {
            return '';
          }
          const name = use_short_name
            ? 'short_name'
            : 'long_name';
          return component[name];
        };

        const address1 = [getNameFromComponent(street_number), getNameFromComponent(route)].join(' ');
        const city = getNameFromComponent(locality);
        const state = getNameFromComponent(administrative_area_level_1, {use_short_name: true});
        const zipCode = getNameFromComponent(postal_code);

        this.updateAddress({address1, city, state, zipCode});
      });
    });
  }

  render() {
    const {
      name,
      address1,
      address2,
      city,
      state,
      zipCode,
      disabled
    } = this.props;

    return (
      <div className="row">
        <AddressField
          autoComplete="company-name"
          label="Name"
          value={name}
          isBig={true}
          disabled={disabled}
          onChange={(e) => this.updateAddress({name: e.target.value})}/>

        <AddressField
          ref='address1'
          autoComplete="address-line1"
          label="Address 1"
          isBig={true}
          value={address1}
          disabled={disabled}
          onChange={(e) => this.updateAddress({address1: e.target.value})}/>

        <AddressField
          label="Address 2"
          autoComplete="address-line2"
          value={address2}
          disabled={disabled}
          onChange={(e) => this.updateAddress({address2: e.target.value})}/>

        <AddressField
          label="City"
          autoComplete="city"
          value={city}
          disabled={disabled}
          onChange={(e) => this.updateAddress({city: e.target.value})}/>

        <AddressField
          label="State"
          autoComplete="state"
          value={state}
          disabled={disabled}
          onChange={(e) => this.updateAddress({state: e.target.value})}/>

        <AddressField
          label="Zip Code"
          autoComplete="zipCode"
          value={zipCode}
          disabled={disabled}
          onChange={(e) => this.updateAddress({zipCode: e.target.value})}/>
      </div>
    )
  }
}

AddressFields.propTypes = {
  updateAddress: PropTypes.func.isRequired,

  name: PropTypes.string.isRequired,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired
}

export {AddressFields, EMPTY_SHIPPING_ADDRESS};


// WEBPACK FOOTER //
// ./src/components/AddressFields.js